"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SFDialog_1 = __importDefault(require("../SFDialog/SFDialog"));
var core_1 = require("@material-ui/core");
require("./SFErrorDialog.css");
var SFErrorDialogContent_1 = __importDefault(require("./SFErrorDialogContent/SFErrorDialogContent"));
var SFErrorDialog = function (_a) {
    var loading = _a.loading, showDialog = _a.showDialog, dialogTitle = _a.dialogTitle, contentTitle = _a.contentTitle, contentMessage = _a.contentMessage, styleClass = _a.styleClass, footer = _a.footer, messageJson = _a.messageJson, onClose = _a.onClose;
    var content;
    if (loading) {
        var loadingStyle = {
            height: '80px',
            width: '80px',
        };
        content = (react_1.default.createElement("div", { className: "loading" },
            react_1.default.createElement(core_1.CircularProgress, { classes: {
                    root: 'progress-bar',
                }, thickness: 1, style: loadingStyle })));
    }
    else {
        content = (react_1.default.createElement(SFErrorDialogContent_1.default, { title: contentTitle, message: contentMessage, messageJson: messageJson }));
    }
    return (react_1.default.createElement(SFDialog_1.default, { open: showDialog, title: dialogTitle, onClose: onClose, content: content, footer: footer, styleClass: "sf-error-dialog " + (styleClass ? styleClass : '') }));
};
exports.default = SFErrorDialog;
